export default {
  //课中活动测验
  testInfo: {
    detail:''
  },
  tsetList: '',
}



// WEBPACK FOOTER //
// ./src/store/kzActivity/test/states.js